// src/index.ts
export * from "@lb-lib/dynamic-component";

// src/frontend.tsx
import { ModalRoot, Toaster } from "@lb-lib/ui";
import { ErrorPage, NotFoundPage } from "@loopbound-ares/components";
import { ShellProvider } from "@loopbound-ares/state";
import React from "react";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider
} from "react-router-dom";

// src/joinPaths.ts
var joinPaths = (...paths) => {
  return `/${paths.map((path) => path.replace(/(^\/+|\/+$)/g, "")).filter((path) => path.length > 0).join("/")}`;
};

// src/frontend.tsx
var Context = React.createContext(null);
var useGetPathWithPrefix = () => {
  let context = React.useContext(Context);
  return (...paths) => joinPaths(context?.path ?? "", ...paths);
};
var createSlice = (routes, opts) => (prefix) => {
  opts?.onInit?.(prefix);
  return {
    routes: {
      path: prefix,
      element: /* @__PURE__ */ React.createElement(Context.Provider, { value: { path: prefix } }, /* @__PURE__ */ React.createElement(Outlet, null)),
      children: routes
    }
  };
};
var createFrontendRouter = ({
  frontends,
  context,
  layout
}) => {
  let router = createBrowserRouter([
    {
      path: "/",
      element: /* @__PURE__ */ React.createElement(ShellProvider, { config: context }, /* @__PURE__ */ React.createElement(Outlet, null), /* @__PURE__ */ React.createElement(Toaster, null), /* @__PURE__ */ React.createElement(ModalRoot, null)),
      errorElement: /* @__PURE__ */ React.createElement(ErrorPage, null),
      children: [
        {
          path: "",
          element: layout,
          children: frontends.map((frontend) => frontend.routes)
        }
      ]
    }
  ]);
  return () => {
    return /* @__PURE__ */ React.createElement(RouterProvider, { router, fallbackElement: /* @__PURE__ */ React.createElement(NotFoundPage, null) });
  };
};
export {
  createFrontendRouter,
  createSlice,
  joinPaths,
  useGetPathWithPrefix
};
//# sourceMappingURL=index.mjs.map